import type { Movie } from '@filmsloth/shared';
import { useT } from '../i18n/index.js';
import { useWatchlist } from '../session/useWatchlist.js';

/**
 * Keeps a film for later.
 *
 * It sits on the card rather than at the end of the session because that is
 * when you know: the group is about to say No to something you would happily
 * watch on your own, and this is the only moment you get to hold on to it.
 */
export function SaveButton({ movie }: { movie: Movie }) {
  const t = useT();
  const { has, toggle } = useWatchlist();
  const saved = has(movie.id, 'saved');

  return (
    <button
      type="button"
      className={`btn btn--ghost btn--small${saved ? ' btn--active' : ''}`}
      aria-pressed={saved}
      onClick={() => void toggle(movie, 'saved')}
    >
      {saved ? '★' : '☆'} {saved ? t('watchlist.saved') : t('watchlist.save')}
    </button>
  );
}
